import gql from 'graphql-tag';

/**
 * What's new (the platform changelog). The entries live in the backend
 * (config/whats-new.php) so the AI assistant reads the same list.
 */
export const WHATS_NEW = gql`
  query WhatsNewEntries {
    whatsNew {
      id date title summary
      sections { heading paragraphs bullets }
      action { label path }
    }
  }
`;
